import { useClient, useDictionary } from "@adamlip/okeoke.client";
import {
  Button,
  Chip,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";
import { UserContext } from "contexts/UserContext";
import moment from "moment";
import { useContext, useEffect } from "react";
import LoadSvg from "utils/LoadSvg-v3";

export default function CouponModalV2({
  isOpen,
  setIsOpen,
  coupon,
  handleActivateCoupon,
  handleDeActivateCoupon,
  currentCoupon,
  activateInProgress,
  setCurrentCoupon,
}) {
  const { getValue } = useDictionary();
  const { stores, selectedStore } = useContext(UserContext);
  const { getName } = useClient();

  useEffect(() => {
    if (coupon) {
      setCurrentCoupon(coupon);
    }
    //eslint-disable-next-line
  }, [coupon]);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(!isOpen)}
      size="2xl"
      classNames={{
        closeButton:
          "z-50 bg-[var(--button-bg-color)] text-[var(--button-text-color)]",
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              {currentCoupon?.name}
            </ModalHeader>
            <ModalBody>
              {currentCoupon && (
                <>
                  <div className="flex flex-col items-start gap-1 justify-start">
                    <p className="text-medium  opacity-50">
                      {getValue("app_v2_coupons_coupon_details")}
                    </p>
                    {Object.values(stores || {}).filter((store) =>
                      (currentCoupon?.stores || []).includes(store.id)
                    ).length > 0 && (
                        <div className="text-sm font-medium">
                          {getValue("app_v2_coupons_availableStores")}
                        </div>
                      )}
                    {Object.values(stores || {})
                      .filter((store) =>
                        (currentCoupon?.stores || []).includes(store.id)
                      )
                      .map((store) => (
                        <Chip
                          startContent={<LoadSvg name="setLocation" />}
                          key={store.id}
                          color={
                            store?.id === selectedStore?.id
                              ? "primary"
                              : "default"
                          }
                        >
                          <p>{store.name}</p>
                        </Chip>
                      ))}
                  </div>
                  <div className="flex flex-col gap-2">
                    {/* <div className="font-semibold text-medium">
                      {currentCoupon?.name}
                    </div> */}
                    <div className="coupon-description">
                      {getName(currentCoupon?.description)}
                    </div>
                    <div className="flex flex-row gap-2">
                      <LoadSvg name="calendar" />
                      <span className="font-medium text-medium">
                        {moment(currentCoupon?.endDate).format(
                          "YYYY.MM.DD HH:mm"
                        )}
                      </span>
                    </div>
                    {/* <div className='flex flex-row gap-2'>
                      <LoadSvg name='checkCircle' />
                      <span>{currentCoupon?.couponMaxClaim - currentCoupon?.claimed}</span>
                      <span>{getValue('app_v2_coupons_pcAvailable')}</span>
                    </div> */}
                  </div>
                </>
              )}
            </ModalBody>
            <ModalFooter className="flex flex-row justify-between">
              {currentCoupon?.active !== true && (
                <Button
                  isLoading={activateInProgress}
                  fullWidth={true}
                  color="primary"
                  className=""
                  onClick={() => handleActivateCoupon(currentCoupon)}
                  isDisabled={activateInProgress}
                >
                  {getValue("app_v2_coupons_activeCoupon")}
                </Button>
              )}
              {currentCoupon?.active === true && (
                <Button
                  isLoading={activateInProgress}
                  fullWidth={true}
                  color="primary"
                  className=""
                  onClick={() => handleDeActivateCoupon(currentCoupon)}
                  isDisabled={activateInProgress}
                >
                  {getValue("app_v2_coupons_alreadyActivated")}
                </Button>
              )}
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
